import { render, staticRenderFns } from "./ListOrders.vue?vue&type=template&id=11f181f2&scoped=true"
import script from "./ListOrders.vue?vue&type=script&lang=ts"
export * from "./ListOrders.vue?vue&type=script&lang=ts"
import style0 from "./ListOrders.vue?vue&type=style&index=0&id=11f181f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f181f2",
  null
  
)

export default component.exports